export enum Routes {
  // Multi inheritance routes
  MULTI_INHERITANCE_DECEDENT_INFO = 'secure/multi-inheritance/decedent-info',
  MULTI_INHERITANCE_DECEDENT_INFORMATION = 'secure/multi-inheritance/decedent-information',
  // Inheritance routes
  INHERITANCE_PERSONAL_INFO = 'secure/inheritance/personal-info',
}
